/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q2Inputs */

const en_pc_faq_q2 = /** @type {(inputs: Pc_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who makes PdfCraft?`)
};

const zh_pc_faq_q2 = /** @type {(inputs: Pc_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 是谁开发的？`)
};

/**
* | output |
* | --- |
* | "Who makes PdfCraft?" |
*
* @param {Pc_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q2 = /** @type {((inputs?: Pc_Faq_Q2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q2(inputs)
	return zh_pc_faq_q2(inputs)
});
export { pc_faq_q2 as "pc.faq.q2" }